import * as React from "react";

function NventIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 72 28"
    >
      <defs>
        <clipPath>
          <rect width="72" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-nvent)">
        <path
          data-name="Path 7136"
          d="M-29.6-13h1.518v2.09a5.337,5.337,0,0,1,4.378-2.4,4.141,4.141,0,0,1,2.376.715,3.888,3.888,0,0,1,1.5,1.87,10.042,10.042,0,0,1,.44,3.4V-1.32h-1.5V-6.886a13.279,13.279,0,0,0-.187-2.772,3.417,3.417,0,0,0-.572-1.232,2.468,2.468,0,0,0-.979-.77,3.537,3.537,0,0,0-1.441-.264,3.6,3.6,0,0,0-1.661.418,4.068,4.068,0,0,0-1.386,1.166,4.223,4.223,0,0,0-.77,1.54,16.169,16.169,0,0,0-.2,3.19v4.29H-29.6Zm12.76,0h1.606l3.894,8.888L-7.447-13h1.606L-11.187-.924h-.264ZM6.721-5.1,8-4.444A6.024,6.024,0,0,1,2.409-.924,5.735,5.735,0,0,1-1.947-2.739,6.13,6.13,0,0,1-3.663-7.106a6.147,6.147,0,0,1,1.727-4.378A5.64,5.64,0,0,1,2.332-13.31,5.857,5.857,0,0,1,6.6-11.616,6.39,6.39,0,0,1,8.393-7H-2.123A4.869,4.869,0,0,0-.792-3.6,4.143,4.143,0,0,0,2.277-2.31,4.751,4.751,0,0,0,6.721-5.1Zm0-3.19a4.1,4.1,0,0,0-1.54-2.618,4.532,4.532,0,0,0-2.838-.946q-3.3,0-4.312,3.564ZM11.627-13h1.518v2.09a5.337,5.337,0,0,1,4.378-2.4,4.141,4.141,0,0,1,2.376.715,3.888,3.888,0,0,1,1.5,1.87,10.042,10.042,0,0,1,.44,3.4V-1.32h-1.5V-6.886a13.279,13.279,0,0,0-.187-2.772,3.417,3.417,0,0,0-.572-1.232,2.468,2.468,0,0,0-.979-.77,3.537,3.537,0,0,0-1.441-.264,3.6,3.6,0,0,0-1.661.418,4.068,4.068,0,0,0-1.386,1.166,4.223,4.223,0,0,0-.77,1.54,16.169,16.169,0,0,0-.2,3.19v4.29H11.627Zm16.7,9.834q0,.594.154.7a1.694,1.694,0,0,0,.792.11h.9v1.276a9.4,9.4,0,0,1-1.452.154,1.927,1.927,0,0,1-1.452-.484,2.136,2.136,0,0,1-.462-1.518v-8.8H24.739V-13h2.068v-4.51h1.518V-13H30.7v1.276H28.325Z"
          transform="translate(35 22)"
        />
      </g>
    </svg>
  );
}

export default NventIcon;
